import api from './api';

export const bondTrusteesAPI = {
  assignTrustee: async (data) => {
    const response = await api.post('/api/bond-trustees', data);
    return response.data;
  },

  getAssignments: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.bondId) queryParams.append('bondId', params.bondId);
    if (params.trusteeId) queryParams.append('trusteeId', params.trusteeId);
    if (params.status) queryParams.append('status', params.status);
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);

    const response = await api.get(`/api/bond-trustees?${queryParams.toString()}`);
    return response.data;
  },

  getBondTrustees: async (bondId) => {
    const response = await api.get(`/api/bond-trustees/bond/${bondId}`);
    return response.data;
  },

  getTrusteeBonds: async (trusteeId) => {
    const response = await api.get(`/api/bond-trustees/trustee/${trusteeId}`);
    return response.data;
  },

  updateAssignment: async (id, data) => {
    const response = await api.patch(`/api/bond-trustees/${id}`, data);
    return response.data;
  },

  removeAssignment: async (id) => {
    const response = await api.delete(`/api/bond-trustees/${id}`);
    return response.data;
  },
};

